.button {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  height: var(--size-control);
  padding: 0 var(--space-3);
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  font-size: var(--text-base);
  font-weight: var(--weight-medium);
  line-height: 1;
  white-space: nowrap;
  user-select: none;
  cursor: pointer;
  transition:
    background-color var(--duration-fast) var(--ease-standard),
    border-color var(--duration-fast) var(--ease-standard),
    color var(--duration-fast) var(--ease-standard);
}

.button:disabled,
.button[aria-disabled="true"] {
  opacity: 0.5;
  pointer-events: none;
}

.iconSlot {
  display: inline-flex;
}

.iconSlot svg {
  width: var(--size-icon);
  height: var(--size-icon);
  flex-shrink: 0;
}

.primary {
  background: var(--color-accent);
  color: var(--color-accent-fg);
}

.primary:hover {
  background: var(--color-accent-hover);
}

.secondary {
  background: var(--color-surface);
  border-color: var(--color-border-strong);
  color: var(--color-fg);
}

.secondary:hover {
  background: var(--color-surface-hover);
}

.ghost {
  background: transparent;
  color: var(--color-fg);
}

.ghost:hover {
  background: var(--color-surface-hover);
}

.danger {
  background: var(--color-fail);
  color: var(--color-accent-fg);
}

.danger:hover {
  opacity: 0.9;
}

.xs {
  height: var(--size-control-xs);
  padding: 0 var(--space-2);
  gap: var(--space-1);
  font-size: var(--text-xs);
}

.xs .iconSlot svg {
  width: var(--size-icon-sm);
  height: var(--size-icon-sm);
}

.sm {
  height: var(--size-control-sm);
  padding: 0 var(--space-2-5);
  gap: var(--space-1-5);
  font-size: var(--text-sm);
}

.lg {
  height: var(--size-control-lg);
  padding: 0 var(--space-4);
  font-size: var(--text-md);
}

.lg .iconSlot svg {
  width: var(--size-icon-lg);
  height: var(--size-icon-lg);
}

.square {
  width: var(--size-control);
  padding: 0;
}

.square.xs {
  width: var(--size-control-xs);
}

.square.sm {
  width: var(--size-control-sm);
}

.square.lg {
  width: var(--size-control-lg);
}

.pressed,
.pressed:hover {
  background: var(--color-accent-subtle);
  color: var(--color-accent-text);
}
